import { navigate } from "gatsby";

export const useRouter = () => {
  return {
    goToLanding: () => navigate("/"),
    goToSummary: () => navigate("/summary"),
    goToQuiz: () => navigate("/quiz"),
    goToCheckout: () => navigate("/checkout"),
    goToSuccess: () => navigate("/success"),
    goBack: () => navigate(-1),
  };
};